import React from 'react';
import cc from 'classnames';

import styles from './FieldInputLevel.module.css';

interface IFieldsLevelerProps {
  dividerBottom?: boolean;
  children: React.ReactNode;
}

const FieldInputLevel = ({ dividerBottom, children }: IFieldsLevelerProps) => (
  <div className={cc(styles.grid, { [styles.dividerBottom]: dividerBottom })}>
    <div className={styles.field}>{children}</div>
  </div>
);

export default FieldInputLevel;
